var _excluded = ["invert", "size"];

var _templateObject;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
var sizes = {
  small: {
    width: "165.65px",
    height: "32px"
  },
  header: {
    width: "207.07px",
    height: "40px"
  },
  medium: {
    width: "248.47px",
    height: "48px"
  },
  large: {
    width: "331.3px",
    height: "64px"
  }
};
export var LogoTypePath = styled.path(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (props) {
  return props.invert ? "#fff" : "#464844";
});

var WorldNomadsLogo = function WorldNomadsLogo(_ref) {
  var invert = _ref.invert,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176 34",
    width: sizes[size].width,
    height: sizes[size].height,
    "aria-label": "World Nomads"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9C00",
    d: "M3.5 6.3c.9 0 1.6.5 2 1.3L7 11.1l4.5-2c.6-.2 1.1-.2 1.6.1l4.3 1.9L19 7.6c.3-.8 1.1-1.3 2-1.3h2.2c0-.1 0-.1-.1-.2-.1-.4-.3-.8-.4-1.1-.5-1.1-1.2-1.9-2.2-2.5-.1 0-.1-.1-.2-.1s-.1-.1-.2-.1H20c-1-.5-2.1-.8-3.2-1h-.3c-.5-.2-1.2-.3-1.8-.3h-.6c1.2.6 2 1.9 2 3.3 0 2.1-1.7 3.8-3.8 3.8S8.5 6.4 8.5 4.3c0-1.4.8-2.7 2-3.3h-.8c-1.8 0-3.8.2-5.4 1.1 0 0-.1 0-.1.1 0 0-.1 0-.1.1-.1-.1-.2 0-.3 0h-.1C2.8 3 2 4 1.5 5.5c0 .1-.1.2-.1.4v.4h2.1zm20.2 4.4h-1.2l-1.9 4.2c-.4.8-1.2 1.3-2 1.3-.3 0-.6-.1-.9-.2l-3.2-1.4v4.6h3.8c1.2 0 2.2 1 2.2 2.2v6.2h2.9c.1-.3.1-.7.2-1.1v-2.1c0-4.5.1-8.4.1-11.4v-2.3m-7.6 18.9v-6.2H8.7v6.2c0 1.2-1 2.2-2.2 2.2H4.7c.8.4 1.6.7 2.6.9.2 0 .4.1.7.1h.1c.2 0 .4.1.7.1h.1c.2 0 .5 0 .7.1h8s.3 0 .4-.1h.1s.3-.1.4-.1h.1s.3-.1.4-.1c.1 0 .3-.1.4-.1.1-.1.3-.1.4-.2.1-.1.3-.1.4-.2.1-.1.3-.1.4-.2h-2.3c-1.2-.2-2.2-1.2-2.2-2.4M6.5 19.1h3.6v-4.5L6.8 16c-1.1.5-2.4 0-2.9-1.1L2 10.7H1c0 3.6-.1 7-.1 9.8 0 2.9 0 5 .3 6.3 0 .1 0 .2.1.3 0 .1 0 .2.1.3h3v-6.2c0-1.1.9-2.1 2.1-2.1"
  }), /*#__PURE__*/React.createElement(LogoTypePath, {
    invert: invert,
    d: "M49.3 9.3l-2.1 8.5-2-8.5h-3.8l-2 8.5-2-8.5h-3.8l3.7 15.5h3.6l2.4-10.1 2.4 10.1h3.7l3.7-15.5m24.7 0v15.5H74V9.3h3.3m-8.2 15.5h-3.6V14.2c1.3-.7 3-1 4.7-1 1 0 1.6.1 2.6.3V17c-.8-.3-1.6-.4-2.4-.4-.4 0-.8.1-1.2.2l-.1 8zm21.5-.3c-1.4.4-3.4.6-5 .6-4 0-6.6-2.1-6.6-6 0-3.6 2.3-6 6-6 .8 0 1.5.1 2 .3V9.3h3.6v15.2zM87 16.6c-.5-.2-1-.3-1.7-.3-1.6 0-2.6 1-2.6 2.7 0 1.9 1.1 3 3 3 .3 0 .8 0 1.3-.1v-5.3zM58.3 13c3.5 0 6.1 2.4 6.1 6s-2.7 6-6.1 6c-3.4 0-6.1-2.4-6.1-6s2.6-6 6.1-6m0 3.1c-1.4 0-2.4 1.1-2.4 2.9s1 2.9 2.4 2.9 2.5-1.1 2.5-2.9c-.1-1.8-1.1-2.9-2.5-2.9m42.8.5v8.2h-3.8V9.3h3.1l5.6 8.4V9.3h3.7v15.5h-2.9M117.2 13c3.5 0 6.1 2.4 6.1 6s-2.7 6-6.1 6-6.1-2.4-6.1-6 2.6-6 6.1-6m0 3.1c-1.4 0-2.4 1.1-2.4 2.9s1 2.9 2.4 2.9 2.5-1.1 2.5-2.9c-.1-1.8-1.1-2.9-2.5-2.9m20.4 1.3c0-.9-.3-1.6-1.5-1.6-.6 0-1.3.2-1.7.4.1.2.2.5.2.9v7.3H131v-7c0-.9-.3-1.6-1.4-1.6-.6 0-.9.1-1.5.2v8.4h-3.6V13.7c1.6-.6 3.6-1 5.4-1 1.4 0 2.5.4 3.2.9.9-.5 2-.9 3.8-.9 2.7 0 4.5 1 4.5 4.6v7.2h-3.6v-7.1h-.2zm11 0c0-1-.9-1.4-1.9-1.4-1.4 0-2.4.4-3.3.9v-3.1c1-.6 2.5-.9 4-.9 2.8 0 4.9 1 4.9 4.3v7.2c-1.1.3-3.1.5-4.7.5-2.8 0-5.2-.8-5.2-3.6 0-2.4 1.9-3.5 5-3.5h1.2v-.4zm0 2.7h-1c-1.1 0-1.7.4-1.7 1.2s.6 1.2 1.5 1.2c.3 0 .8 0 1.2-.1v-2.3zm17.7.8c1.2.8 2.7 1.3 3.8 1.3.8 0 1.4-.2 1.4-.7s-.3-.7-1.4-.9c-2.8-.4-4-1.5-4-3.7 0-2.7 2-3.9 4.7-3.9 1.5 0 2.4.3 3.5.9V17c-1.1-.7-2.2-1.1-3.3-1.1-1 0-1.3.4-1.3.7 0 .4.3.7 1.2.8 3.3.5 4.2 1.8 4.2 3.9 0 2.6-1.9 3.7-4.8 3.7-1.4 0-2.9-.3-3.9-.9l-.1-3.2zm-1.5 3.3c-1.4.4-3.4.6-5 .6-4 0-6.6-2.1-6.6-6 0-3.6 2.3-6 6-6 .8 0 1.5.1 2 .3V9.3h3.6v14.9zm-3.6-7.9c-.5-.2-1-.3-1.7-.3-1.6 0-2.6 1-2.6 2.7 0 1.9 1.1 3 3 3 .3 0 .8 0 1.3-.1v-5.3z"
  }));
};

export default WorldNomadsLogo;